export default __webpack_public_path__ + "static/media/top.41e6fd46.png";